export const exportConfigurationTemplate = {
  TaOrganization: {
    name: 'Organization',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          TaParameter: {
            name: 'Settings',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
          ContactData: {
            name: 'Contact Data',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
          TaAddress: {
            name: 'Addresses',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
    },
  },
  DeliveryChain: {
    name: 'Delivery Chains',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          Channel: {
            name: 'Channels',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  TsElementType: {
    name: 'Item Types',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          Tag: {
            name: 'Labels',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
      Rule: {
        name: 'Rules',
        exportValue: false,
        isPublic: true,
        isSelectable: true,
        children: {
          IndicatorType: {
            name: 'Status Indicators',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  IndicatorType: {
    name: 'Status Indicators',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          IconRule: {
            name: 'Icon Rules',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
    },
  },
  TaRole: {
    name: 'Roles',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          TaParameter: {
            name: 'Settings',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
      Privilege: {
        name: 'Privileges',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          TaAclPrivilege: {
            name: 'Role ACLs',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  TaEventType: {
    name: 'Event Types',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
      },
      ItemRule: {
        name: 'Item Rules',
        exportValue: false,
        isPublic: true,
        isSelectable: true,
        children: {
          TaLocation: {
            name: 'Locations',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          IndicatorType: {
            name: 'Status Indicators',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          Tag: {
            name: 'Labels',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
      TaskRule: {
        name: 'Task Rules',
        exportValue: false,
        isPublic: true,
        isSelectable: true,
        children: {
          TaTaskType: {
            name: 'Task Types',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          IndicatorType: {
            name: 'Status Indicators',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          TaUser: {
            name: 'Users',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          Tag: {
            name: 'Labels',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  TaEventGenerationRule: {
    name: 'Event Generation Rules',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          TaEventType: {
            name: 'Event Types',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          IndicatorType: {
            name: 'Status Indicators',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          TsElementType: {
            name: 'Item Types',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          Tag: {
            name: 'Labels',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
          TsGeometry: {
            name: 'Geometries',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  TaProfile: {
    name: 'Profiles',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          TaParameter: {
            name: 'Settings',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
    },
  },
  TaTaskType: {
    name: 'Task Types',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          Tag: {
            name: 'Labels',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
          TsElementType: {
            name: 'Item Types',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
          TaUser: {
            name: 'Users',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
      EventLogging: {
        name: 'Event Logging',
        exportValue: false,
        isPublic: true,
        isSelectable: true,
        children: {
          TaEventType: {
            name: 'Event Types',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  Tag: {
    name: 'Labels',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
      },
      ItemTypeRestriction: {
        name: 'Item Type Restrictions',
        exportValue: false,
        isPublic: true,
        isSelectable: true,
        children: {
          TsElementType: {
            name: 'Item Types',
            exportValue: true,
            isPublic: true,
            isSelectable: false,
          },
        },
      },
    },
  },
  TsGeometry: {
    name: 'Geometries',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
      },
    },
  },
  TaLocation: {
    name: 'Locations',
    exportValue: false,
    isPublic: true,
    isSelectable: true,
    configSection: {
      Main: {
        name: 'General Settings',
        exportValue: true,
        isPublic: true,
        isSelectable: false,
        children: {
          TsElementType: {
            name: 'Item Types',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
          TsGeometry: {
            name: 'Geometries',
            exportValue: true,
            isPublic: true,
            isSelectable: true,
          },
        },
      },
    },
  },
};
